module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"hello world!"}}')
  delete Component.options._Ctor
}
